module.exports = __webpack_public_path__ + "static/bjorn.de2392e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatars/bjorn.jpg
// module id = 47
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512